import { Avatar } from 'src/components/avatar';
import Avatars from 'src/components/common/avatar/avatars';
import SvgEnthuseV1 from 'src/components/icons/enthuse-v1';
import SvgCommentsV1 from 'src/components/icons/comments-v1';
import SvgShareV1 from 'src/components/icons/share-v1';

import Media from 'src/components/common/media/media';
// import Share from 'src/components/common/share/share';
import dayHepler from 'src/heplers/day';
import { ReactNode, useState } from 'react';
import SvgIcSettings from 'src/components/icons/ic-settings';
import Dropdowns from 'src/components/common/dropdowns/dropdowns';
import is from 'is_js';
import Router from 'next/router';
import { isDesktop } from 'react-device-detect';
import {
  useDisclosure,
  Box,
  Text,
  Flex,
  useMediaQuery,
} from '@chakra-ui/react';
// import SvgPick from 'src/components/icons/pick';
import { getProfileFullNameOrUsername } from 'src/app/profile/utils';
import { ArticleDetailModal } from 'src/app/article/detail-modal';
import { imageOptimize } from 'src/service/image';
import { EnthuseButton } from 'src/app/article/components/enthuse-button';
import { useArticleEnthuseMutation } from 'src/app/article/hooks/use-enthuse';

interface Props {
  data: any;
  className?: string;
  menu?: ReactNode;
  fns?: Array<string>;
  isSmall?: boolean;
}

// block object-cover w-full h-50

export function Creation({
  data,
  className = '',
  fns = [],
  menu,
  isSmall,
}: Props) {
  const repplModal = useDisclosure();

  const [isLessThan709] = useMediaQuery('(max-width: 709px)');

  const [newData, setNewData] = useState({
    enthuseCount: data['enthuseCount'],
    isEnthused: data['isEnthused'],
  });

  const { mutateAsync: enthuse } = useArticleEnthuseMutation(
    data['contentID'],
    setNewData
  );

  if (is.empty(data)) {
    return (
      <div className="animate-pulse">
        <div className="card h-80 skeleton-line rounded mt-4 mb-2" />
      </div>
    );
  }

  let link = `/${data.author?.['username']}/${data['contentID']}`;

  if (data['source'] === 'REPPL' && Router.pathname === '/reppl/[rid]') {
    link = `/reppl/${data['sourceID']}/episode/${data['contentID']}`;
  }

  const getIsStudio = (filter) => {
    if (filter === 'avatar') {
      if (
        data['author']?.profileImgURL !== '' &&
        data['author']?.profileImgURL
      ) {
        return [
          imageOptimize({
            url: data['author']?.profileImgURL,
            imgContainer: 'avatar',
          }),
        ];
      }
      return (
        imageOptimize({ url: data['avatarUrl'], imgContainer: 'avatar' }) ||
        team.map(
          (t) =>
            t &&
            imageOptimize({ url: t['profileImgURL'], imgContainer: 'avatar' })
        )
      );
    }
    if (filter === 'username') {
      return (
        getProfileFullNameOrUsername(data['author']) ||
        data['username'] ||
        '1TM Member'
      );
    }
  };

  const coCreators = data['coCreators'] ? data['coCreators'] : [];
  const team = [data['author'], ...coCreators];
  const avatarUrl = getIsStudio('avatar');

  const media = data['media'] || [
    {
      type: 'img',
      coverUrl: imageOptimize({
        url: data['coverImgURL'],
        imgContainer: 'postCover',
      }),
    },
  ];

  // const contentType = 'eid';

  const linkHandle = () => {
    if (Router.pathname === '/reppl/[rid]/[episodeType]') {
      repplModal.onOpen();
    } else if (Router.pathname === '/[username]/collections/[cid]') {
      repplModal.onOpen();
    } else if (Router.pathname === '/reppl/[rid]/collections/[cid]') {
      repplModal.onOpen();
    } else {
      Router.push({ pathname: link });
    }
    // Router.push(
    //   {
    //     pathname: Router.asPath,
    //     query: {
    //       [contentType]: data['contentID'],
    //       type: data['postType'] === 'MEDIA' ? 'mediaPost' : 'storyPost',
    //     },
    //   },
    //   undefined,
    //   { shallow: true }
    // );
  };

  let shownumber = 2;
  let dot = false;

  if (
    data['categories'].length === 2 &&
    data['categories'][0].length + data['categories'][1].length > 32
  ) {
    shownumber = 1;
    dot = true;
  }
  if (data['categories'].length > 2) {
    dot = true;
    if (data['categories'][0].length + data['categories'][1].length > 30) {
      shownumber = 1;
    }
  }

  if (isSmall) {
    return (
      <div
        role="button"
        tabIndex={0}
        className="p-4 bg-white rounded-md flex justify-between"
        onClick={linkHandle}
        onKeyDown={linkHandle}
      >
        <div className="creationTextPart mr-2">
          <p className="line-clamp-2 text-sm text-gray-900 font-bold">
            {data['title']}
          </p>
          {data['updatedAt'] && (
            <span className="text-xs text-gray-500 font-bold">
              {dayHepler.fromNow(data['updatedAt'], true)}
            </span>
          )}
        </div>
        <div className="rounded-sm overflow-hidden creationImageBlock">
          <Media
            media={media}
            className={`${data['postType']} ? 'bg-gray-900' : ''`}
          />
        </div>
        <style jsx global>{`
          .creationImageBlock {
            height: 65px;
            width: 87px;
          }
          .creationImageBlock img {
            width: 87px !important;
            height: 65px !important;
            object-fit: cover;
          }
          .creationTextPart {
            max-width: calc(100% - 95px);
          }
        `}</style>
      </div>
    );
  }
  return (
    <Box
      w="100%"
      m="0px"
      className={`align-top relative ${
        !isLessThan709 ? '' : 'mb-2'
      } creation-card rounded overflow-hidden flex-shrink-0 ${className}`}
      borderRadius="24px"
    >
      {menu && !isLessThan709 && (
        <Box className="absolute right-0 top-2 z-10 items-center">{menu}</Box>
      )}
      {is.not.empty(fns) && isDesktop && (
        <div className="absolute right-1 top-3 z-50">
          <Dropdowns
            className="text-sm font-medium"
            items={[fns]}
            dataID={
              data['source'] === 'REPPL' ? data['contentID'] : data['objectID']
            }
            buttonComponent={
              <SvgIcSettings
                fontSize="20px"
                className="inline mr-2 align-text-bottom text-white"
              />
            }
          />
        </div>
      )}
      <div
        role="button"
        tabIndex={0}
        onClick={linkHandle}
        onKeyDown={linkHandle}
        style={{
          height: '100%',
          backgroundColor: 'white',
        }}
      >
        <Box h="200px" className="relative">
          <Media
            media={media}
            menu={menu}
            className={`${data['postType'] === 'MEDIA' ? 'bg-gray-900' : ''}`}
          />

          <div className="absolute p-4 bottom-0 flex justify-between w-full items-end">
            {avatarUrl.length > 1 && (
              <div className="flex items-center">
                <Avatars
                  width="1.875rem"
                  height="1.875rem"
                  imgs={avatarUrl.slice(0, 3)}
                />
                {avatarUrl.length > 3 && (
                  <span className="text-gray-400 text-xs ml-2">
                    +{avatarUrl.length - 3}
                  </span>
                )}
              </div>
            )}

            {avatarUrl.length === 1 && (
              <div className="flex">
                <Avatar
                  width={30}
                  height={30}
                  svgClassName="border border-white"
                  author={data['author']}
                  src={
                    avatarUrl.length === 1
                      ? imageOptimize({
                          url: avatarUrl[0],
                          imgContainer: 'avatar',
                        })
                      : null
                  }
                />
                <div className="ml-2">
                  <Text
                    className="block text-white"
                    fontSize={{ base: 'xs', md: 'md' }}
                    lineHeight="17px"
                    fontWeight={{ base: '700', md: 'bold' }}
                  >
                    {getIsStudio('username')}
                  </Text>
                  <Text
                    className="font-medium block text-xs text-white"
                    lineHeight="18px"
                  >
                    {data['role'] || 'creator'}
                  </Text>
                </div>
              </div>
            )}
            {data['createdAt'] && (
              <Text
                className="text-white text-xs"
                fontWeight={{ base: '500', md: 'bold' }}
              >
                {dayHepler.localizedFormat(data['createdAt'], 'MMM DD')}
              </Text>
            )}
          </div>
        </Box>
        <Flex
          bgColor="white"
          flexDirection="column"
          p={{
            base: `16px ${className === 'bg-white' ? '16px' : '24px'} 16px`,
            md: '16px 24px',
          }}
          className="relative"
          justifyContent="space-between"
          h="calc(100% - 200px)"
        >
          <Box>
            {data['pinned'] && (
              <div className="mb-2 text-olive-300 text-xs font-bold">
                FEATURED
              </div>
            )}
            <Text
              className="font-medium line-clamp-2"
              fontWeight={{ base: '400', md: '500' }}
              color="gray.900"
              lineHeight="24px"
            >
              {data['title']}
            </Text>
            <Text
              className="text-sm card-desc text-gray-500 line-clamp-3"
              mb="12px"
              pt="12px"
            >
              {data['excerpts']}
            </Text>
            {data['categories'].length > 0 && (
              <div className="mt-3 mb-3 flex">
                {data['categories'].slice(0, shownumber).map((tag, key) => {
                  const mkey = `key${key}`;
                  if (tag === '') return null;
                  return (
                    <Text
                      lineHeight="18px"
                      key={mkey}
                      className="whitespace-nowrap px-3 py-1 mr-1 text-xs bg-denim-50 text-denim-500 rounded-full"
                    >
                      {tag}
                    </Text>
                  );
                })}
                {dot && (
                  <span className="px-3 py-1 mr-1 text-xs bg-denim-50 text-denim-500 rounded-full">
                    ...
                  </span>
                )}
              </div>
            )}

            {className === 'bg-white' && (
              <div
                role="button"
                className="border rounded shadow-sm my-4"
                tabIndex={0}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => {
                  if (e.code === 'Enter') {
                    e.stopPropagation();
                  }
                }}
              >
                <EnthuseButton
                  width="48px"
                  height="48px"
                  isEnthuse={newData['isEnthused']}
                  likesCount={newData['enthuseCount']}
                  textClass="text-blue-500"
                  onEnthuse={() => {
                    enthuse({
                      enthuse: !newData['isEnthused'],
                      objectId: data['contentID'],
                      objectType: 'EPISODE',
                      ownerID: data['author']?.['userID'],
                    });
                  }}
                />
              </div>
            )}
          </Box>
          <Box>
            <Flex
              justifyContent={`${
                className === 'bg-white' ? 'end' : 'space-between'
              }`}
            >
              {className !== 'bg-white' && (
                <div className="w-full text-gray-400">
                  <SvgEnthuseV1 className="inline mr-1" fontSize="20px" />

                  <span className="text-xs">
                    {new Intl.NumberFormat().format(data['enthuseCount'])}
                  </span>
                </div>
              )}
              <Flex className="text-steel-400">
                <a
                  role="button"
                  tabIndex={0}
                  onClick={linkHandle}
                  onKeyDown={(e) => {
                    if (e.code === 'Enter') {
                      linkHandle();
                    }
                  }}
                >
                  <SvgCommentsV1 fontSize="20px" mr="16px" />
                </a>
                <a role="button" tabIndex={0}>
                  <SvgShareV1 fontSize="20px" />
                </a>
              </Flex>
            </Flex>
          </Box>
        </Flex>
      </div>

      <ArticleDetailModal
        source={data['source']}
        modal={repplModal}
        publish
        id={data['contentID']}
      />
    </Box>
  );
}

export default Creation;
